import { createContext } from 'react';

const bedContext = createContext();

export default bedContext;
